import { URLS } from '../../config-urls';

type Site = `cew` | `ga`;
type Env = `prod` | `stage` | `dev`;

const deriveEnv = (): Env => {
    const siteName = process.env.GATSBY_SITE_NAME || ``;
    const endpoint =
        siteName === `ga`
            ? process.env.ENDPOINT_GA || ``
            : process.env.ENDPOINT_CEW || ``;
    if (endpoint.includes(`stage-`)) return `stage`;
    if (endpoint.includes(`dev-`)) return `dev`;
    return `prod`;
};

const ENV = deriveEnv();

export const getDestinationUrl = (targetSite: Site): string => {
    return `https://${URLS[targetSite][ENV][0]}`;
};
